import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/internet-explorer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M483 159.7C493.9 135.1 504.5 99.3 504.5 71.8 504.5-0.9 424.8-26.5 294.8 33.3 187.2 26.1 83.6 106.9 57.7 219.7 88.6 184.9 136 137.4 179.7 118.6 125.4 166.9 79.1 228 44 291.7 23.2 329.7 0 390.9 0 436.7 0 535.3 92.9 523.2 180.3 478.8 211.7 494.2 246.8 494.3 281.9 494.3 379.1 494.3 466.2 440 498.8 348.3H377.9C325.4 436.9 181.1 401.3 181.1 300.9H509.9C516.3 257.3 508.2 205.2 483 159.7zM64.6 346.9C82.3 398 118.3 442.7 164.8 470.2 76.1 519.1-8.4 499.3 64.6 346.9zM180.5 238C182.5 182.9 230.8 143.1 284.5 143.1 337.9 143.1 386.5 182.9 388.5 238H180.5zM365.1 50.4C386.5 40.1 413.6 28.4 437.6 28.4 469.1 28.4 491.9 50.1 491.9 82.1 491.9 102.1 484.5 131.1 477.3 150 451.1 107.7 411.3 68.4 365.1 50.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/internet-explorer.js
// module id = XQuP
// module chunks = 144